import React from 'react';
import { useHistory } from 'react-router-dom';
import { withTranslation, useTranslation } from 'react-i18next';
import './FooterSection.css';

const FooterSection = () => {
  const [t] = useTranslation('common');

  const footerText = t('xAgro.footer.text', { returnObjects: true });

  const combinedText = Array.isArray(footerText)
    ? footerText.map((item, idx) => {
        if (item.type === 'strong') {
          return <strong key={`ft_${idx}`}>{item.content}</strong>;
        }
        return item.content;
      })
    : footerText;

  const routeChange = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    else window.location.hash = '#contact';
  };

  return (
    <section
      id="xAgroFooter"
      className="section overflow-hidden d-flex align-items-center justify-content-center flex-column"
    >
      <div className="row text-start">
        {/* Eyebrow / badge de contexto */}
        <div className="col-md-12 d-flex justify-content-center">
          <span className="xAgro-footer-eyebrow">
            <span className="xAgro-footer-eyebrow-dot" />
            {t('xAgro.footer.eyebrow', { defaultValue: 'Agricultura de precisión' })}
          </span>
        </div>

        <div className="col-md-12 d-flex justify-content-center mt-4">
          <div className='xAgro-home-img'>
            <img src="/assets/img/xAgro/xagro_brand_transparent.png" alt="xAgro" />
          </div>
        </div>

        {/* Título */}
        <div className="col-md-12 my-3">
          <h2 className="xAgro-footer-text mx-auto text-center">
            {combinedText}
          </h2>
        </div>

        {/* Subtítulo opcional */}
        <div className="col-md-12 d-flex justify-content-center">
          <p className="xAgro-footer-subtitle text-center">
            {t('xAgro.footer.subtitle', {
              defaultValue:
                'Sensores, algoritmos y cuadernos de campo en una sola plataforma. Mide, decide y reduce recursos.',
            })}
          </p>

        </div>

        {/* Grupo de botones */}
        <div className="col-md-12 d-flex justify-content-center mt-4">
          <div className="xAgro-footer-cta-group">
            <button className="xAgro-footer-btn" onClick={routeChange}>
              {t('xAgro.footer.cta', { defaultValue: t('xAgro.footer.button') })}
              <svg
                width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2.5"
                strokeLinecap="round" strokeLinejoin="round"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
          </div>

        </div>

        {/* Señales de confianza */}
        <div className="col-md-12 d-flex justify-content-center mt-4">
          <div className="xAgro-footer-trust">
            <span className="xAgro-footer-trust-item">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2.5"
                strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6L9 17l-5-5" />
              </svg>
              {t('xAgro.footer.trust1', { defaultValue: 'Datos en tiempo real' })}
            </span>
            <span className="xAgro-footer-trust-item">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2.5"
                strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6L9 17l-5-5" />
              </svg>
              {t('xAgro.footer.trust2', { defaultValue: 'Menos consumo de recursos' })}
            </span>
            <span className="xAgro-footer-trust-item">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2.5"
                strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6L9 17l-5-5" />
              </svg>
              {t('xAgro.footer.trust3', { defaultValue: 'Soporte local' })}
            </span>
          </div>
        </div>

      </div>
    </section>
  );
};

export default withTranslation('common')(FooterSection);